import { render, staticRenderFns } from "./EventPopupHeader.vue?vue&type=template&id=03aabb14&scoped=true&"
import script from "./EventPopupHeader.vue?vue&type=script&lang=ts&"
export * from "./EventPopupHeader.vue?vue&type=script&lang=ts&"
import style0 from "./EventPopupHeader.vue?vue&type=style&index=0&id=03aabb14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03aabb14",
  null
  
)

export default component.exports